<template>
  <div>
    <v-container fluid >
      <v-row no-gutters>
        <v-col cols="12">
          <p class="grey lighten-2 pa-2">
            <span class="font-weight-black ">Descripción:</span>
            <br>
            <span ma-5>Este campo convierte una preguna en una check Box, 
              se emplea en confirmaciones sencillas como aceptaciones de alguna condición. Su valo es fijo Verdaro o Falso </span>
          </p>
        </v-col> 
        <v-col cols="12">
          <PreguntaControl
            v-model="pregunta"
            :campos="campos"
            :camposIndex="camposIndex" 
          >  
          </PreguntaControl>
        </v-col>
        <v-col cols="12" align-end>
          <span>Obligatorio</span>
          <v-radio-group v-model="obligatorio" row >
            <v-radio
              label="SI"
              value="1"
            ></v-radio>
            <v-radio
              label="NO"
              value="0"
            ></v-radio>
          </v-radio-group>
        </v-col>  
      </v-row>  
      <v-row no-gutters>
        <v-col cols="12" align-end v-if="errors.length" style="font-size: 12px;" class="red--text">
          <p >
            <b>Por favor, corrija el(los) siguiente(s) error(es):</b>
            <ul>
              <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
            </ul>
          </p>
        </v-col>  
        <v-col cols="12" align-end>
          <v-btn block color="btncolor" elevation="2" dark @click="Guardar">
           <h2> Guardar </h2>
          </v-btn>
        </v-col> 
      </v-row>  
    </v-container>   
  </div>
</template>

<script>
import axiosServices from '@/services/axiosServices.js'
import PreguntaControl from '@/components/dragdrop/Campos/PreguntaControl.vue'

export default {
  name:"CheckBoxConfig",
  components: {
    PreguntaControl,
  },
  props: {
    campos: {
      type: Object,
      required: true
    },
    camposIndex: {
      type: Number,
      required: true
    }, 
  },
  data() {
    return {
      pregunta  : '',
      obligatorio : '',
      aPreguntas : [],
      errors: [],
    }
  },
  mounted () {
    this.getPreguntas()
    this.cargarDatos()
  },
  methods: {
    async getPreguntas() {
      const axiosPreguntas = await axiosServices.getConfiguration('buildDinamicos/preguntas', true )
      this.aPreguntas = axiosPreguntas.aData
    },
    validarInfo(){

      this.errors = []

      if(this.pregunta == '' || this.pregunta == null || this.pregunta == 'undefined' ){
       this.errors.push('Debe Seleccionar una pregunta!')
      }
      if(this.obligatorio == ''){
       this.errors.push('Debe indicar si es obligatorio!')
      }
      
      // valido si la pregunta no esta repetida
      const auxboard = this.$store.state.board.columns[1].campos
      const preguntaIndex = auxboard.findIndex(campo =>
        ( campo.idPregunta == this.pregunta && campo.NombreTipo != "Grupo" && campo.NombreTipo !="Item")
      )

      if(preguntaIndex != this.camposIndex && preguntaIndex > -1){
       this.errors.push('La pregunta seleccionada esta en otro campo, No la puede emplear!')
      }


      if( this.errors.length==0){
        return false 
      } else {
        return true 
      }

    },
    Guardar(){

      if( this.validarInfo() ){
        return
      }

      const auxPregunta = this.aPreguntas.filter( preguntas => preguntas.idFD_Pregunta == this.pregunta )

      const auxcampo = {
          id: this.campos.id,
          ancho: this.campos.ancho,
          userAssigned: this.campos.userAssigned,
          idTipoCampo: this.campos.idTipoCampo,
          NombreTipo: this.campos.NombreTipo,
          name: this.campos.name,
          idPregunta: this.pregunta ,
          pregunta: auxPregunta[0].Pregunta,
          obligatorio: this.obligatorio,
          valor: this.campos.valor ,
      }

      this.$store.dispatch('salvarCampoBoard',{camposIndex:this.camposIndex, campo:auxcampo })

    },
    cargarDatos() {
      this.errors = []
      this.pregunta = this.campos.idPregunta == 0 ? 0 : this.campos.idPregunta
      this.obligatorio = this.campos.obligatorio == '' ? '' : this.campos.obligatorio
    }
  },
  watch: {
    camposIndex(newValue, oldValue) {
      if (newValue !== oldValue){
        this.cargarDatos()
      }
    },
    pregunta(){
      this.getPreguntas()
    }
  },
}
</script>

<style lang="scss" scoped>

</style>